const searchModuleMessages = { RECENT_SEARCH_HEADING: 'Recent Search' };

export default searchModuleMessages;
